import { useEffect, useMemo, useState } from 'react'
import { useWindowScroll } from 'react-use'
import { useIsMobile } from '@/hooks/useMobile'
import { DESKTOP_SCROLL_THRESHOLD } from '@/lib/constants'

/**
 * Returns `true` once the user has scrolled past a small threshold
 * (`y > 0` on mobile, `y > DESKTOP_SCROLL_THRESHOLD` on desktop).
 * Returns `false` during SSR and before hydration completes.
 */
export function useIsScrolled() {
	const isMobile = useIsMobile()
	const state = useWindowScroll()

	const [mounted, setMounted] = useState(false)
	useEffect(() => {
		setMounted(true)
	}, [])

	return useMemo(() => {
		if (!mounted) return false // Default for ssr
		return isMobile ? state.y > 0 : state.y > DESKTOP_SCROLL_THRESHOLD
	}, [mounted, isMobile, state.y])
}
